document.addEventListener("DOMContentLoaded", function() {
  const jciCountrySelector = document.querySelectorAll(".jci-country-selector");
  jciCountrySelector.forEach(element => {
    const selector = element.querySelector(".country-selector");
    const toggle = selector.querySelector(".selector-toggle");

    toggle.addEventListener("click", () => {
        selector.classList.toggle("open");
    });

    // Close if clicking outside
    document.addEventListener("click", (e) => {
        if (!selector.contains(e.target)) {
        selector.classList.remove("open");
        }
    });
  });
});